/* Casa do Violino — MAESTRO inline information dialogs.
   Native accessible dialogs keep visitors on the Shopify page.
   Existing links remain valid fallbacks without JS.
*/
(() => {
  'use strict';
  let returnFocus = null;

  const getDialog = (trigger) =>
    trigger.closest('.m-cross')?.querySelector('[data-cdv-modal]') ||
    document.querySelector('[data-cdv-modal]');

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-cdv-modal-open]');
    if (opener) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
          event.ctrlKey || event.shiftKey || event.altKey) return;
      const dialog = getDialog(opener);
      const key = opener.getAttribute('data-cdv-modal-open');
      const panel = dialog?.querySelector(
        '[data-cdv-modal-panel="' + key + '"]'
      );
      if (!dialog || !panel || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) dialog.close();
      dialog.querySelectorAll('[data-cdv-modal-panel]').forEach((node) => {
        node.hidden = node !== panel;
      });
      const heading = panel.querySelector('h3[id]');
      if (heading) dialog.setAttribute('aria-labelledby', heading.id);
      const scroll = dialog.querySelector('.m-cross__dialog-scroll');
      if (scroll) scroll.scrollTop = 0;
      returnFocus = opener;
      dialog.showModal();
      dialog.querySelector('[data-cdv-modal-close]')?.focus();
      return;
    }

    const closer = target.closest('[data-cdv-modal-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (!dialog?.open) return;
      dialog.close();
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDialogElement) ||
        !target.matches('[data-cdv-modal]')) return;
    const bounds = target.getBoundingClientRect();
    const clickedOutside = event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;
    if (clickedOutside) target.close();
  });

  document.addEventListener('close', (event) => {
    if (!event.target?.matches?.('[data-cdv-modal]')) return;
    const previous = returnFocus;
    returnFocus = null;
    if (previous?.isConnected) previous.focus({ preventScroll: true });
  }, true);
})();
